import * as React from "react";

function SvgLogout(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path clipRule="evenodd" d="M7 1.441A5.559 5.559 0 107 12.56 5.559 5.559 0 007 1.44zm-4.95.61a7 7 0 119.9 9.899 7 7 0 01-9.9-9.9zm5.138 2.346a.72.72 0 011.02 0L10.3 6.49a.72.72 0 010 1.02L8.207 9.603a.72.72 0 11-1.019-1.02l.863-.862H4.21a.72.72 0 010-1.442h3.842l-.863-.863a.72.72 0 010-1.019z" /></svg>;
}

export default SvgLogout;